function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let cookiesList = decodedCookie.split(';');
  for(let i = 0; i < cookiesList.length; i++) {
    let cookie = cookiesList[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return '';
}

function setCookie(cname, cvalue, exdays, sameSite) {
  const date = new Date();
  date.setTime(date.getTime() + (exdays*24*60*60*1000));
  let expires = 'expires='+ date.toUTCString();
  if (sameSite) {
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/;SameSite=' + sameSite;
  } else {
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/;SameSite=Lax';
  }
}

function deleteCookieFromDjango(name) {
  if (!getCookie(name)) return;
  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.finloup.com";
}

(function reporting() {
    function setCookieDom(cname, cvalue, exdays, domain, sameSite) {
      const date = new Date();
      date.setTime(date.getTime() + (exdays*24*60*60*1000));
      let expires = 'expires='+ date.toUTCString();
      if (sameSite) {
        document.cookie = cname + '=' + cvalue + ';' + 'domain=' + domain + ';' + expires + ';path=/;SameSite=' + sameSite;
      } else {
        document.cookie = cname + '=' + cvalue + ';' + 'domain=' + domain + ';' + expires + ';path=/;SameSite=Lax';
      }
    }

    if(window.location.href.indexOf('leasing-iphone-16-series') !== -1 ||
        window.location.href.indexOf('laptop-flexible-plan') !== -1 ||
        window.location.href.indexOf('leasing-latest-iphone') !== -1){
        if (window.location.search && window.location.search.match(/fbclid=/)){
            setCookieDom('ltraffic', 'FB', 90, '.finloup.com','Strict;Secure');
        }
        if (window.location.search && window.location.search.match(/mc_cid=/)){
            setCookieDom('ltraffic', 'EML', 90, '.finloup.com','Strict;Secure');
        }
        if (window.location.search && window.location.search.match(/ttclid=/)){
            setCookieDom('ltraffic', 'TT', 90, '.finloup.com','Strict;Secure');
        }
        if (window.location.search && window.location.search.match(/gclid=/)){
            setCookieDom('ltraffic', 'GADS', 90, '.finloup.com','Strict;Secure');
        }
    }
    var locationPath = window.location.origin + window.location.pathname;
    if((window.location.search && window.location.search.match(/fbclid=/)) ||
        (window.location.search && window.location.search.match(/mc_cid=/)) ||
        (window.location.search && window.location.search.match(/ttclid=/)) ||
        (window.location.search && window.location.search.match(/gclid=/))) {
        if (window.location.href.indexOf('leasing-iphone-16-series') !== -1) {
            setCookieDom('ltrafficland', locationPath, 90, '.finloup.com', 'Strict;Secure');
        }
        if (window.location.href.indexOf('laptop-flexible-plan') !== -1) {
            setCookieDom('ltrafficland', locationPath, 90, '.finloup.com', 'Strict;Secure');
        }
        if (window.location.href.indexOf('leasing-latest-iphone') !== -1) {
            setCookieDom('ltrafficland', locationPath, 90, '.finloup.com', 'Strict;Secure');
        }
    }
})();
